export const MESSAGE = {
  PAYMENT_FAILED:
    "Payment Failed: We hit a tiny turbulence. Re-aligning your path 🛫",
};

export const WEB_LINK = {
  BECOME_MEMBER: "https://www.sabehub.com/execution-space/enquiry//workspace-enquiry-form",
  SABE_LOCATION: "https://maps.app.goo.gl/w8UYDMukdZC7LZdE9",
  WHATSAPP_CHANNEL:
    "https://api.whatsapp.com/send?phone=917340887648&text=Tricity%E2%80%99s%201st%20elite%20workspace%20for%20remote%20workers",
  TERM_CONDITION:
    "https://www.sabehub.com/workspace/termsandconditions?spredirect=1",
  PRIVACY_POLICY:
    "https://www.sabehub.com/workspace/cancellation-refunds-wallet-policy?spredirect=1",
  ABOUT_US: "https://www.sabehub.com/about",
  CLEAN_FUEL_CAFE: "https://www.sabehub.com/cafe/tf",
};

export const STORAGE_KEY = {
  API_ACCESS_TOKEN_DATA: "apiAccessToken",
  USER_PROFILE_DATA: "workspaceUserProfileData",
  PAYMENT_SUCCESS_DATA: "paymentSuccessData",
  SELECTED_SLOT_DATA: "selectedSlotData",
  SELECTED_MEMBERSHIP_DATA: "selectedMembershipData",
  SELECTED_MEMBERSHIP_PLAN_DATA: "selectedMembershipPlanData",
  SELECTED_FULL_DAY_PASS_DATA: "selectedFullDayPassData",
  SELECTED_CREDIT_PLAN_DATA: "selectedCreditPlanData",
  RESERVATION_CANCEL_DATA: "reservationCancelData",
  SELECTED_RESERVATION_DATA: "selectedReservationData",
  SELECTED_PAYMENT_HISTORY_DATA: "selectedPaymentHistoryData",

  CALENDAR_SELECTED_TAB: "calendarSelectedTab",
  CALENDAR_SELECTED_DATE: "calendarSelectedDate",
  WORKSPACE_DEEPLINK_DATA: "wsmDeepLinkData",
  SELECTED_HOME_TAB_DATA: "selectedHomeTab",
};

export const STRING = {
  APP_EXIT_POPUP_TITLE: "Switching Spaces",
  APP_EXIT_POPUP_MESSAGE:
    "You’re about to get redirected to an external link. Do you want to go ahead?",
  APP_EXIT_POPUP_BUTTON: "Yes, let’s go",
  CANCEL_RESERVATION_POPUP_TITLE: "Are you serious ?",
  CANCEL_RESERVATION_POPUP_MESSAGE:
    "Are you sure you want to cancel this reservation?",
  CANCEL_RESERVATION_POPUP_BUTTON: "Yes",
  MEMBERSHIP_EXPIRE_INFO_TITLE: "Membership Expiry Alert",
  MEMBERSHIP_EXPIRE_INFO_SUB_TITLE:
    "You can book events only until Membership validity date. Please renew your membership to continue booking beyond this date.",
  MEMBERSHIP_EXPIRE_INFO_BUTTON_TITLE: "View Plans",
};
